import { useBooleanFeatureFlag } from '@databases/feature-flags/hooks';
import { defaultStoreUtils } from '@databases/redux';
import { selectDatabaseDraftByContentId } from '@databases/redux/changesets/selectors';
import useView from '@databases/views/useView';

interface useHasNumberedEntriesProps {
  contentId: string;
  scope: string;
}

const useHasNumberedEntries = ({ contentId, scope }: useHasNumberedEntriesProps) => {
  const isNumberedEntriesEnabled = useBooleanFeatureFlag(
    'databases-frontend-numbered-entries'
  );
  const { view } = useView();
  const numberOfEntries = defaultStoreUtils.useEqualSelector((state) => {
    const databaseDraftView = selectDatabaseDraftByContentId(state, {
      contentId,
      scope,
      viewSettings: view.settings,
      includeDeleted: true,
    });
    return databaseDraftView.entries.length;
  });

  return (
    isNumberedEntriesEnabled &&
    view.settings.layout.showNumberedEntries &&
    numberOfEntries !== 0
  );
};

export default useHasNumberedEntries;
